import { render, staticRenderFns } from "./betSlip4d.vue?vue&type=template&id=62a63146&lang=pug&"
import script from "./betSlip4d.vue?vue&type=script&lang=js&"
export * from "./betSlip4d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports